module.exports = __webpack_public_path__ + "static/img/4006_phase_function_Paper_Points.429858f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4006_phase_function_Paper_Points.png
// module id = Rqrs
// module chunks = 0